import React, { Component, PropTypes } from 'react';
import { inject, observer } from 'mobx-react';

import { winhydro } from "../../../../actions/api";

import DataTable from '../../../DataTable';
import Spinner from "../../../Spinner";
import Form, { FormBody, SelectInput, TextInput } from "../../../Form";
import ReactDropzone from "react-dropzone";
import { BASE_URL } from "../../../../config";
import request from "superagent";
import { token } from "../../../../libs/localStorage";
import { observable, toJS } from "mobx";

const {
  getAllAvailableStationIndexes,
  getDistinctRatingTableListingsByStationIndex
} = winhydro;

@inject('hydrologyStore', 'stationStore')
@observer
class TableList extends Component {
  @observable file = null;

  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
  }

  static contextTypes = {
    notify: PropTypes.object.isRequired,
  };

  componentWillMount() {
    const { hydrologyStore } = this.props
    if(!hydrologyStore.stations.length) hydrologyStore.fetchStations();
  }

  // handleDelete(idOrIds) {
  //   const { notify } = this.context;
  //   console.log('handleDelete', idOrIds);
  //   this.props.metaDataStore.removeItems(idOrIds)
  //     .then(() => {
  //       notify.success();
  //     })
  //     .catch((err) => {
  //       notify.error(err);
  //     });
  // }

  handleStationIndexChange = (e) => {
    const { setSelectedStation, fetchRatingTableListingsByStationIndex, setRatingTables } = this.props.hydrologyStore;
    setSelectedStation(e.target.value);

    if (e.target.value !== '') {
      fetchRatingTableListingsByStationIndex(e.target.value);
    } else {
      setRatingTables([]);
    }
  };

  slug = 'hydrology/rt_method/table_list';
  columns = [
    { key: 'id', label: 'ID' },
    { key: 'serial_no', label: 'Serial No.' },
    { key: 'rating_type_no', label: 'Type No.' },
    { key: 'start_date', label: 'Start Date' },
    { key: 'end_date', label: 'End Date' },
  ];

  handleSave = e => {
    e.preventDefault();

    if (this.file && this.file.name) {

      const { notify } = this.context;
      const url = `${BASE_URL}/winhydro/generic/import`;

      const req = request.post(url).set('Authorization', `Bearer ${token.getEncoded()}`);

      req.attach('test', this.file);

      req.end((err, res) => {
        window.location.reload();

        if (err) {
          console.log(err);
          notify.error(err);
        } else {
          // dataExportStore.fetchItems();
          // router.push(this.slug);
        }
      })
    }
  };

  onDrop = (files) => {
    this.file = files[0];
  };

  handleDelete = (id) => {
    console.log(id);
    this.props.hydrologyStore.deleteRatingTable(id);
  };

  render() {
    // const { route: { metaDataStore }, children } = this.props;
    const { stationStore } = this.props;
    const { children, history, hydrologyStore } = this.props;
    const { ratingTables, loading, selectedStation, stations, associatedTSSStation } = hydrologyStore;

    return (
      <div>
        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
          <Form>
            <FormBody>
              <div style={{ width: '100%' }}>
                <SelectInput
                  label={'Station'}
                  // fields={{label: 'station_index', value: 'station_index'}}
                  fields={{ label: 'name', value: 'id' }}
                  value={selectedStation}
                  // options={stations}
                  options={stationStore.items}
                  onChange={this.handleStationIndexChange}
                  filterOptions={stationStore.filterStations}
                />
              </div>
              {selectedStation !== '' && associatedTSSStation && associatedTSSStation.identifier &&
                <TextInput readOnly={true} label={'Identifier'} value={associatedTSSStation.identifier} />}
              {selectedStation !== '' && associatedTSSStation && associatedTSSStation.name &&
                <TextInput readOnly={true} label={'Name'} value={associatedTSSStation.name} />}
            </FormBody>
          </Form>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Upload Rating Table: </label>
            {/*<button onClick={this.onOpenAddFile}>{!!this.file ? this.file.name :"Choose file"}</button>*/}
            <ReactDropzone ref="dropzone"
              onDrop={this.onDrop}
              style={{
                display: "flex",
                flexDirection: 'column',
                justifyContent: 'center',
                textAlign: "center",
                height: "35px",
                minWidth: "310px",
                cursor: "pointer",
                border: '1px solid lightgrey'
              }}>
              <span style={{ display: "block", color: '#5d5d5d' }} id={"filename"}>
                {!!this.file ? this.file.name : 'Click or drag a file here to upload!'}
              </span>
            </ReactDropzone>
            <Form>
              <FormBody>
                <button onClick={this.handleSave}>Upload</button>
              </FormBody>
            </Form>
          </div>
        </div>
        {selectedStation !== '' && <DataTable
          data={ratingTables}
          onSelect={(rowData) => {
            history.push(`/hydrology/rt_method/rating_tables?station_index=${selectedStation}&rating_type_no=${rowData.rating_type_no}`);
          }}
          sortRow={items => items.sort((a, b) => {
            if (a.start_date < b.start_date) return -1; else if (a.start_date > b.start_date) return 1; else return 0;
          })}
          slug={this.slug}
          columns={this.columns}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
          resource='hydrology-table-list'
        />}
        {loading && <Spinner />}
        {children}
      </div>
    );
  }
}

export default TableList;



// WEBPACK FOOTER //
// ./src/components/Hydrology/RT Method/Table/NewList.js